export const STATUS_CODE = {
    SUCCESS : 200,
    CONFLICT : 409,
    ERROR : 500,
    NOT_EXISTS : 404,
    NOT_MATCHED : 204,
}